module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-tab"
  }, [_vm._t("header"), _vm._v(" "), _c('div', {
    ref: "viewBoxBody",
    staticClass: "weui-tab__panel vux-fix-safari-overflow-scrolling",
    style: ({
      paddingTop: _vm.bodyPaddingTop,
      paddingBottom: _vm.bodyPaddingBottom
    }),
    attrs: {
      "id": "vux_view_box_body"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("bottom")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dd223a6"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/view-box/index.vue
// module id = 525
// module chunks = 1